import type { ISiteMetadata } from '@anywayseo/tools';
import { graphql, useStaticQuery } from 'gatsby';

interface IUseSiteReturn {
  metadata: ISiteMetadata;
}

function useSite(): IUseSiteReturn {
  const data = useStaticQuery(graphql`
    query GetSite {
      site {
        siteMetadata {
          title
          description
          siteUrl
          lang
          currency
        }
      }
    }
  `);

  return {
    metadata: data.site.siteMetadata,
  };
}

export default useSite;
